import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';

const IS_GOOGLE_MEET_LINK_USED = gql`
  query IsGoogleMeetLinkUsed($url: String!) {
    isGoogleMeetLinkUsed(url: $url)
  }
`;

const IS_ZOOM_LINK_USED = gql`
  query IsZoomLinkUsed($url: String!) {
    isZoomLinkUsed(url: $url)
  }
`;

export const isGoogleMeetLinkUsed = (url: string): Promise<boolean> =>
  gqlClient
    .request<{ isGoogleMeetLinkUsed: boolean }>(IS_GOOGLE_MEET_LINK_USED, { url })
    .then((res) => res.isGoogleMeetLinkUsed);

export const isZoomLinkUsed = (url: string): Promise<boolean> =>
  gqlClient
    .request<{ isZoomLinkUsed: boolean }>(IS_ZOOM_LINK_USED, { url })
    .then((res) => res.isZoomLinkUsed);
